import React from 'react';
import { GuidePageQuery_displayPage as DisplayPage } from '../../generated/types/GuidePageQuery';
import { hrefFor } from '../../routers';
import { usePLPParams } from '../../hooks/usePLPParams';
import { PageFilterLink } from './PageFilterLink';
import { PageFilterPanel } from './PageFilterPanel';

import './PageFilterPages.scss';

type PageFilterCategoryProps = {
  guideSubPages?: DisplayPage['guideSubPages'];
  mobile?: boolean;
  onClose: () => void;
};

export const PageFilterPages: React.FC<PageFilterCategoryProps> = ({
  mobile = false,
  onClose,
  guideSubPages
}) => {
  const {
    params: { guideSlug }
  } = usePLPParams();
  const content =
    guideSubPages &&
    guideSubPages.map(
      page =>
        page &&
        page.slug && (
          <PageFilterLink
            selected={guideSlug === page.slug}
            key={page.slug}
            to={hrefFor.GuidePage({ guideSlug: page.slug })}
            onClick={onClose}
          >
            <span>{page.name}</span>
          </PageFilterLink>
        )
    );

  if (mobile) {
    return (
      <PageFilterPanel onClose={onClose} title="Pages">
        {content}
      </PageFilterPanel>
    );
  }

  return (
    <div className="PageFilterPages">
      <h4 className="PageFilterPages__title">Pages</h4>
      {content}
    </div>
  );
};
